<template id="page">
  <div >
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{$t("main_title")}}
    </h1>
    <div class="main_wrap">
      <div v-if="$props.main.isLoad === false">
         <div class="spinnerC">
          <svg class="spinner" viewBox="0 0 50 50">
            <circle
              class="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>
        </div>
      </div>
      <div v-if="$props.main.isLoad === true">
        <div class="mobiSection" v-for="hot in $props.main.subcategory" :key="hot.key">
          <div class="mobiSection__header">
            <h2 class="mobiTitle md">
              <img class="mobiIcon" :src="IconHotPick_g4all" alt="" />
              <span class="text_color">{{ $t("hotpicks") }} - 
                <span v-if="lang_g4all !== 'english'">{{ hot[`title_${lang_g4all}`] }}</span>
                <span v-if="lang_g4all === 'english'">{{ hot.subcategory }}</span>
              </span>
            </h2>
            <div class=" link right">
              <router-link :to="{path: 'hotpicks', query: { q: hot.subcategory } }" class="browse_link">{{$t("view_more")}} ></router-link>
            </div>
          </div>
          <div class="mobiSection__content">
            <div class="row">
              <div v-for="game in $props.main.hotpicks[hot.subcategory]" :key="game.key" class="col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem">
                <div v-if="game.subcategory === hot.subcategory" >
                  <router-link class="mobiApp" :to="{name: 'DetailPage', params: { id: game.content_id } }" >
                    <div v-if="game.content_type === 'application/x-zip-compressed'" class="mobibadge badge--html5">
                      <img src="../../assets/mobizone/imgs/html5-badge.png"/>
                    </div>
                    <div class="mobiApp__thumb">
                      <img class="img_wrp" :src="game.thumbnail_url" alt="" />
                    </div>
                    <div class="mobiApp__info">
                        <!-- <h3 class="mobiTitle sm text_color">{{ game.content_name }}</h3> -->
                        <span v-if="lang_g4all !== 'english'">
                          <h3 class="mobiTitle sm text_color" v-if="game[`cont_name_${lang_g4all}`] !== ''">{{ game[`cont_name_${lang_g4all}`] }}</h3>
                          <h3 class="mobiTitle sm text_color" v-else>{{ game[`cont_name_english`] }}</h3>
                        </span>
                        <span v-else>
                          <h3 class="mobiTitle sm text_color">{{ game[`cont_name_english`] }}</h3>
                        </span>
                      <div>
                        <star-rating :inline="true" :star-size="16" :read-only="true" :increment="0.01" :show-rating="false" :border-width="2" border-color="#feb801" inactive-color="transparent" active-color="#ffb902" :rounded-corners= "false" :star-points="[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17]"
                        :rating="Number(game.rating)"></star-rating>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);
export default {
  data() {
    return {
      games: {}
    };
  },
  components:{
    StarRating
  },
  props: ["main"],
  computed: mapGetters([
    // "allSubGame_g4all",
    // "allStoreGameData_g4all",
    "IconHotPick_g4all",
    "IconPopular_g4all",
    "lang_g4all",
    "country_g4all"
    // "hpisLoad_g4all"
  ]),
  created() {
    // this.fetchHomeHotPick_g4all();
  },
  mounted() {},
  methods: {
    // ...mapActions(["fetchHomeHotPick_g4all"])
  }
};
</script>

<style scoped>
.main_title {
  color: black;
}

.browse_link {
  color: black;
}

/* .img_wrp {
  width: 200px;
  height: 200px;
} */
</style>



// WEBPACK FOOTER //
// src/components/games4all/Home.vue